import React, {
    useEffect,
    useContext,
} from "react"

import {
    Context,
    EMETLContext,
} from "../Model/Contexts/AppContext"

import ViewAssessments from "./ViewAssessments"

const QuarterlyData = () => {
    const {
        assessmentData: {
            assessments: {
                value: assessments,
                update: setAssessments,
            },
        }
    } = useContext(Context) as EMETLContext
    
    useEffect(() => {
        if(!!assessments?.length)
            setAssessments([])
        
    }, [])
    return  (
        <ViewAssessments 
            wantsQuarterlyData
        />
    )
}

export default QuarterlyData